import { render, staticRenderFns } from "./InquiryView.vue?vue&type=template&id=0a7d2071&"
import script from "./InquiryView.vue?vue&type=script&lang=js&"
export * from "./InquiryView.vue?vue&type=script&lang=js&"
import style0 from "./InquiryView.vue?vue&type=style&index=0&id=0a7d2071&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports